<template>
    <div :data-component="$options.name">
        <div
            ref="mapWrapper"
            class="h-full w-full"
        ></div>
    </div>
</template>
<script lang="ts" src="./MsGoogleMaps.ts" />
